import { useCallback, useContext, useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import About from './pages/About';
import Dignitaries from './pages/Dignitaries';
import Gallery from './pages/Gallery';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/ContactUs';
import Footer from './components/Footer';
import ScrollToTop from './components/Scroller';
import toast from 'react-hot-toast';
import NotFound from './pages/NotFound';
import { schoolContext } from './contexts/SchoolContextProvider';
import { fetchGuestUserToken } from './services/authServices';
import { getFormEntriesByFormName } from './services/formServices';
import { FORMNAMES } from './utilities/codes';
import { loaderContext } from './contexts/LoaderProvider';
import TopTeachers from './components/TopTeachers';
import TopStudents from './pages/TopStudents';
import NotProfileFound from './components/NotProfile';
import DynamicPage from './pages/DynamicPage';
import LandingPage from './pages/LandingPage';
import NoticeBoard from './pages/NoticeBoard';
import Calendar from './pages/Calendar';

function App() {
  const [guestToken, setGuestToken] = useState(false);
  const { schoolDetails, setSchoolDetails } = useContext(schoolContext);
  const { setIsLoading } = useContext(loaderContext);
  const [apiLoaded, setApiLoaded] = useState(false)

  const getSchoolDetail = useCallback(async () => {
    const saveThemeColor = (schoolInfo) => {
      const root = document.documentElement;
      if (schoolInfo?.primary) { root.style.setProperty('--color-primary', schoolInfo?.primary); }
      if (schoolInfo?.secondary) { root.style.setProperty('--color-secondary', schoolInfo?.secondary); }
      if (schoolInfo?.accent) { root.style.setProperty('--color-accent', schoolInfo?.accent); }
    }
    try {
      setIsLoading(true);
      const resDetails = await getFormEntriesByFormName(FORMNAMES.SCHOOLPROFILE);
      const resSchoolInfo = resDetails[0]?.payload;

      if (resSchoolInfo) {
        setSchoolDetails(resSchoolInfo);

        if (resSchoolInfo?.logo?.fileUrl) {
          localStorage.setItem("school_logo", resSchoolInfo.logo.fileUrl);
        }

        saveThemeColor(resSchoolInfo);
      } else {
        toast.error("Error in getting School details");
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setIsLoading(false);
      setApiLoaded(true);
    }
  }, [setIsLoading, setSchoolDetails]);

  const fetchGuestToken = useCallback(async () => {
    try {
      const responseToken = await fetchGuestUserToken();
      if (responseToken) {
        setGuestToken(true);
        getSchoolDetail();
      }
      else toast.error("Session expired. Please refresh to continue")
    } catch (error) {
      toast.error(error?.message);
    }
  }, [getSchoolDetail]);

  useEffect(() => {
    fetchGuestToken();
  }, [fetchGuestToken]);

  return (
    <>
      {!apiLoaded ? null : (
        guestToken && schoolDetails?.publish ? (
          <div className="font-sans text-gray-700">
            <ScrollToTop />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dignitaries" element={<Dignitaries />} />
              <Route path="/topteachers" element={<TopTeachers />} />
              <Route path="/topstudents" element={<TopStudents />} />
              <Route path="/pages" element={<LandingPage />} />
              <Route path="/pages/:slug" element={<DynamicPage />} />
              <Route path="/notice" element={<NoticeBoard />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </div>
        ) : (
          <NotProfileFound />
        )
      )}

    </>
  );
}

export default App;
